var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-select",
    _vm._g(
      _vm._b(
        {
          attrs: {
            clearable: "",
            label: "Query residues",
            "persistent-hint": "",
          },
          scopedSlots: _vm._u([
            {
              key: "selection",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("multi-slider", {
                    staticStyle: { flex: "1 1 100%", width: "100%" },
                    attrs: {
                      values: _vm.queryresidues,
                      value: item,
                      disabled: "",
                      "background-color": _vm.color,
                    },
                  }),
                ]
              },
            },
            {
              key: "item",
              fn: function (ref) {
                var item = ref.item
                return [
                  _c("multi-slider", {
                    staticStyle: { flex: "1 1 100%", width: "100%" },
                    attrs: {
                      values: _vm.queryresidues,
                      value: item,
                      disabled: "",
                      "background-color": _vm.color,
                    },
                  }),
                ]
              },
            },
          ]),
        },
        "v-select",
        _vm.$attrs,
        false
      ),
      _vm.$listeners
    )
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }